import * as React from "react"
import { navigate } from "gatsby";
import Layout from "../components/Layout/Layout";
import T from "../components/T/T";


export default function Contacts() {
    return (
        <>
            <title><T>contact-us-title</T></title>

            <Layout>
                <div className="uk-container">
                    <div className="back-action">
                        <button className="back-button" onClick={() => navigate(-2)}>
                            <span><T>back-button</T></span>
                        </button>
                    </div>

                    <div className="terms-body-holder">
                        <h1 className="block-title"><T>contact-us-title</T></h1>

                        <div className="block-content email-content">
                            <a href="mailto:nc@help.xela.co" className="email-box">
                                <T>contact-us-email</T>
                            </a>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
